module.exports = __webpack_public_path__ + "img/star.eb6a289c.svg";